__webpack_require__.p = "https://frontend-platform-package-main.ui.moostaging.com/";